// extracted by mini-css-extract-plugin
module.exports = {"layoutColumns":"SrUtilityProfitAdminProcessAddressPage--layoutColumns--WXO2D","highlightYellowFadeIn":"SrUtilityProfitAdminProcessAddressPage--highlightYellowFadeIn--9bbPe"};